enum GenerateForecast {
  GENERATE_FORECAST = 'billing-periods/generate-forecast'
}

export default GenerateForecast;
